module.exports = __webpack_public_path__ + "img/shuixi01.13b56218.png";